import { PageHero } from "../components/common/PageHero";
import { SectionHeading } from "../components/common/SectionHeading";
import { Stagger, StaggerItem } from "../components/common/Reveal";
import { CareerForm } from "../components/forms/CareerForm";
import { CTAButton } from "../components/common/CTAButton";
import { careerAreas, images } from "../data/content";
import { Briefcase } from "@phosphor-icons/react";

export default function Careers() {
    return (
        <>
            <PageHero
                overline="Careers"
                breadcrumb="Careers"
                title="Build Your Career with FRONTX"
                subtitle="Explore opportunities across field operations, construction, BPO, logistics, IT, AI data operations, healthcare, education and more."
                image={images.careers}
            />

            <section className="bg-white">
                <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
                    <SectionHeading
                        overline="Opportunity Areas"
                        title="Where you can grow with us"
                        subtitle="We hire across a wide range of functions and industries — for permanent, contract and project-based roles."
                    />
                    <Stagger className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                        {careerAreas.map((a) => (
                            <StaggerItem key={a}>
                                <div className="group flex items-center gap-3 p-5 rounded-sm border border-slate-200 bg-[#f8fafc] hover:border-brand hover:-translate-y-1 transition-all duration-300">
                                    <Briefcase size={24} weight="duotone" className="text-brand" />
                                    <span className="text-sm font-semibold text-navy">{a}</span>
                                </div>
                            </StaggerItem>
                        ))}
                    </Stagger>
                    <div className="mt-10 flex flex-wrap gap-4">
                        <CTAButton href="#resume" variant="outlineNavy" data-testid="view-open-positions">View Open Positions</CTAButton>
                        <CTAButton href="#resume" variant="primary">Submit Your Resume</CTAButton>
                    </div>
                </div>
            </section>

            <section className="bg-[#f8fafc]" id="resume" data-testid="resume-section">
                <div className="mx-auto max-w-[1100px] px-5 lg:px-10 py-24 lg:py-32">
                    <SectionHeading overline="Apply Now" title="Submit Your Resume" subtitle="Share your details and our HR team will connect with you for suitable openings." align="center" />
                    <div className="mt-12 bg-white border border-slate-200 rounded-sm p-6 lg:p-10">
                        <CareerForm />
                    </div>
                </div>
            </section>
        </>
    );
}
